/**
 * ZipcodeMapDrawer - 邮编地图围栏详情右侧抽屉
 *
 * 邮编 tab、围栏 tab、围栏黑名单终审页共用：全屏宽度、无自带头部，
 * 由 ZipcodeMapPage 页内「返回」按钮关闭。
 */
import React from 'react';
import { Drawer } from 'antd';
import { ZipcodeMapPage } from './ZipcodeMapPage';

interface ZipcodeMapDrawerProps {
    /** 当前查看的邮编，为空时抽屉关闭 */
    zipcode: string | null;
    /** 来源标识：终审页传 'geofence-review'（终审 level=2），其余不传（一级审核 level=1） */
    from?: string;
    onClose: () => void;
}

const ZipcodeMapDrawer: React.FC<ZipcodeMapDrawerProps> = ({ zipcode, from, onClose }) => (
    <Drawer
        placement="right"
        width="100%"
        open={!!zipcode}
        onClose={onClose}
        closable={false}
        destroyOnHidden
        // 防止浏览器全屏按 Esc 退出时连带关闭抽屉
        keyboard={false}
        maskClosable={false}
        styles={{ body: { padding: 0, overflow: 'hidden' } }}
    >
        {zipcode && (
            <ZipcodeMapPage embedded zipcode={zipcode} from={from} onClose={onClose} />
        )}
    </Drawer>
);

export default ZipcodeMapDrawer;
